import * as RouteHelper from "RouteHelper";

import { withRouter } from "react-router-dom";
import React, { PureComponent } from "react";

import PropTypes from "prop-types";

import styles from './Breadcrumbs.module.scss'

/**
 * Shows clickable breadcrumb navigation based on route
 */
class Breadcrumbs extends PureComponent {
  renderCrumbs = breadcrumbChain => {

    if (!(breadcrumbChain && breadcrumbChain.length)) {
      return null;
    }

    const crumbs = breadcrumbChain.reduce((acc, curr, index) => {
        acc.push(
            <span
            className={`${styles.breadcrumb} ${breadcrumbChain.length === index + 1 ? styles['breadcrumb-current'] : ''} ${this.props.className || ''}`}
            key={`breadcrumb-${index}`}
          >
          {
            breadcrumbChain.length === index + 1 ?
            curr.title :
            <React.Fragment>
                {curr.title}
                <span className={styles.separator}>/</span>
            </React.Fragment>
          }
          </span>
        )
        return acc
    }, [])

    return crumbs && crumbs.length ? crumbs : null;
  };

  render() {
    const routeDef = RouteHelper.getDefByPathname(this.props.location.pathname);
    let breadcrumbChain = RouteHelper.getBreadcrumbChain(routeDef);

    if (this.props.breadcrumbs){
      return <div className={styles.breadcrumbs}>{this.props.breadcrumbs}</div>;
    }

    return <div className={styles.breadcrumbs}>{this.renderCrumbs(breadcrumbChain)}</div>;
  }

  static propTypes = {
    className: PropTypes.object,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    breadcrumbs: PropTypes.string
  };
}

export default withRouter(Breadcrumbs);
